import React from 'react'
import './Iqac.css'
import imagese1 from "../Home/images/IMG_20230513_095610.jpg"
const IQAC = () => {
  return (
    <div data-aos="fade-up">
    <div className='main-conatiner-iqac'>
        <div className='conatiner-iqac-image-1'>
           {/* <img className='conatiner-iqac-image' src={imagese1} alt="image" />  */}
        </div>
        </div>
<div data-aos="fade-up">

        <div className='conatiner-iqac-About'>
        {/* <h1>About</h1> <br />    */}
        <p className='para-about-iac'>To monitor standards of the higher educational institutions the UGC has established an autonomous body namely, National Assessment and Accreditation Council (NAAC) in September 1994. In order to maintain all standards of technical expertise of faculty as well as work of research, training and personality development, the  AICTE and NAAC have emphasised dire need of Internal Quality Assurance cell in all the colleges / institutions. The Internal quality assurance mechanism of any institution is called as “Internal Quality Assurance Cell (IQAC)” is meant for planning, guiding and monitoring Quality Assurance (QA) and Quality Enhancement (QE) activities of the same.  IQAC has the potential to become a driving force for enhancing quality by working out different strategies and techniques to remove deficiencies. <br/><br/>
        
       Therefore, Pt. LR college of Technology, Faridabad has established an Internal Quality Assurance Cell (IQAC) for maintaining the momentum of quality consciousness. The IQAC coordinates the efforts and measures of all departments of college towards academic excellence and growth of institution. Infact working of IQAC has become very essential to maintain record of updating data as per changing technology. It is being used as an internal mechanism for maintenance, assurance and enhancement of the quality culture of education.</p>
        
      
        <div className='para-iqac'>
          <h1><strong> <u>Objectives</u> </strong></h1>
          <p>
          •	To develop a system for aware, consistent and action to improve the academic and administrative performance of the institution. <br />
          •	To promote measures for institutional functioning towards quality enhancement through∙ internalization of quality culture and institutionalization of best practices. <br />
          •	To uplift standard of training, research and expansion participation of the institution of various state and national forums. 

          </p>
          <h1><strong> <u>Strategies</u> </strong></h1>
          <p>
          •	Ensuring timely, efficient and progressive performance of academic, administrative and financial responsibilities, <br />
          •	Relevant and quality academic/ research programmes,<br />
          •	Equitable access to and affordability of academic programmes for various sections of society,<br />
          •	Optimization and combination of new methods of teaching and learning,<br />
          •	The credibility of assessment and evaluation process,<br />
          •	Ensuring the adequacy, maintenance and proper provision of support structure and services,<br />
          •	Implementation of all tools activity to fill loop holes and introduce modern technique.<br />
          </p>
          <h1><strong> <u>Functions</u> </strong></h1>
          <p>
          •	To develop  the parameters for various academic and administrative activities of the institution to raise quality of education, <br />
          •	Collection and analysis of feedback from all stakeholders on quality-related institutional processes and distribution of information on various quality parameters to all stakeholders,<br />
          •	To arrange and conduct inter and intra institutional workshops, seminars on quality related themes and promotion of quality circles, <br />
          •	To ensure documentation of the various programmes/activities leading to quality improvement, <br />
          •	To prepare and maintain of institutional database through MIS for the purpose of maintaining /enhancing the institutional quality, and update it from time to time.<br />
          •	To ensure periodical conduct of Academic and Administrative Audit and to follow-up desired action.<br />
          •	To Prepare and submit the Annual Quality Assurance Report (AQAR) as per guidelines and parameters of NAAC. <br />


          </p>
          </div>
          </div>
    </div>
    </div>
  )
}

export default IQAC;